"use client";
import { Link } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
import styles from "./Menu.module.scss";
import CurrentTime from "@/components/UI/CurrentTime/CurrentTime";
import LocaleSwitcher from "@/components/UI/LocaleSwitcher/LocaleSwitcher";
import { useState } from "react";
import Image from "next/image";

interface MenuProps {
  isClose: boolean;
}

export default function Menu({ isClose }: MenuProps) {
  const t = useTranslations("Menu");

  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);

  const toggleDropdown = (dropdown: string) => {
    setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
  };

  return (
    <div className={`${styles.menu} ${isClose && styles.close}`}>
      <ul className={`${styles.menu__list}`}>
        <li className={styles.menu__item}>
          <Link className={styles.menu__link} href="/bonuses">
            <Image
              src="/images/icons/bonuses.svg"
              className={styles.menu__link_icon}
              height={32}
              width={32}
              alt=""
            />
            <span className={styles.menu__link_title}>{t("bonuses")}</span>
          </Link>
        </li>
        <li className={styles.menu__item}>
          <Link className={styles.menu__link} href="/">
            <Image
              src="/images/icons/promo.svg"
              className={styles.menu__link_icon}
              height={32}
              width={32}
              alt=""
            />
            <span className={styles.menu__link_title}>{t("promo")}</span>
          </Link>
        </li>
        {/* <li className={styles.menu__item}>
          <Link className={styles.menu__link} href="/">
            <Image
              src="/images/icons/vip.svg"
              className={styles.menu__link_icon}
              height={32}
              width={32}
              alt=""
            />
            <span className={styles.menu__link_title}>{t("vip")}</span>
          </Link>
        </li> */}
      </ul>

      {/* dropdown */}

      <ul className={styles.menu__list}>
        {/* <li className={styles.menu__item}>
          <div
            className={`${styles.dropdown} ${activeDropdown === "slots" ? styles.dropdown_active : ""}`}
          >
            <button className={styles.dropdown__button} onClick={() => toggleDropdown("slots")}>
              <svg
                className={styles.dropdown__button_icon}
                viewBox="0 0 24 24"
                width="18"
                height="100%"
              >
                <use href="/images/sprite.svg#burger-slots-dark"></use>
              </svg>
              <span className={`${styles.dropdown__button_title} ${styles.menu__link_title}`}>
                {t("slots")}
              </span>

              <svg
                className={styles.dropdown__button_icon_arrow}
                viewBox="0 0 12 7"
                fill="currentColor"
                width="12"
                height="100%"
              >
                <use href="/images/sprite.svg#arrow-1-down"></use>
              </svg>
            </button>

            {isClose && (
              <ul className={styles.dropdown__list}>
                <li className={styles.dropdown__list_item}>
                  <Link className={styles.dropdown__link} href={"/"}>
                    <svg
                      className={styles.dropdown__link_icon}
                      viewBox="0 0 24 24"
                      width="18"
                      height="100%"
                      fill="currentColor"
                    >
                      <use href="/images/sprite.svg#bonus-buy"></use>
                    </svg>
                    {t("bunus_buy")}
                  </Link>
                </li>

                <li className={styles.dropdown__list_item}>
                  <Link className={styles.dropdown__link} href={"/"}>
                    <svg
                      className={styles.dropdown__link_icon}
                      viewBox="0 0 24 24"
                      width="18"
                      height="100%"
                      fill="currentColor"
                    >
                      <use href="/images/sprite.svg#books"></use>
                    </svg>
                    {t("books")}
                  </Link>
                </li>

                <li className={styles.dropdown__list_item}>
                  <Link className={styles.dropdown__link} href={"/"}>
                    <svg
                      className={styles.dropdown__link_icon}
                      viewBox="0 0 24 24"
                      width="18"
                      height="100%"
                      fill="currentColor"
                    >
                      <use href="/images/sprite.svg#fruits"></use>
                    </svg>
                    {t("fruits")}
                  </Link>
                </li>

                <li className={styles.dropdown__list_item}>
                  <Link className={styles.dropdown__link} href={"/"}>
                    <svg
                      className={styles.dropdown__link_icon}
                      viewBox="0 0 24 24"
                      width="18"
                      height="100%"
                      fill="currentColor"
                    >
                      <use href="/images/sprite.svg#all"></use>
                    </svg>
                    {t("all_slots")}
                  </Link>
                </li>
              </ul>
            )}
          </div>
        </li> */}

        <li className={styles.menu__item}>
          <Link className={styles.menu__link} href="/games/slots">
            <svg className={styles.menu__link_icon} viewBox="0 0 24 24" width="18" height="100%">
              <use href="/images/sprite.svg#burger-slots-dark"></use>
            </svg>
            <span className={styles.menu__link_title}>{t("all_slots")}</span>
          </Link>
        </li>

        <li className={styles.menu__item}>
          <div
            className={`${styles.dropdown} ${activeDropdown === "liveCasino" ? styles.dropdown_active : ""}`}
          >
            <button
              className={styles.dropdown__button}
              onClick={() => toggleDropdown("liveCasino")}
            >
              <svg
                className={styles.dropdown__button_icon}
                viewBox="0 0 24 24"
                width="18"
                height="100%"
              >
                <use href="/images/sprite.svg#burger-casino-dark"></use>
              </svg>
              <span className={`${styles.dropdown__button_title} ${styles.menu__link_title}`}>
                {t("liveCasino")}
              </span>

              <svg
                className={styles.dropdown__button_icon_arrow}
                viewBox="0 0 12 7"
                fill="currentColor"
                width="12"
                height="100%"
              >
                <use href="/images/sprite.svg#arrow-1-down"></use>
              </svg>
            </button>

            {isClose && (
              <ul className={styles.dropdown__list}>
                <li className={styles.dropdown__list_item}>
                  <Link className={styles.dropdown__link} href={"/games/roulette"}>
                    <svg
                      className={styles.dropdown__link_icon}
                      viewBox="0 0 24 24"
                      width="18"
                      height="100%"
                      fill="currentColor"
                    >
                      <use href="/images/sprite.svg#roullete"></use>
                    </svg>
                    {t("roulette")}
                  </Link>
                </li>

                <li className={styles.dropdown__list_item}>
                  <Link className={styles.dropdown__link} href={"/games/blackjack"}>
                    <svg
                      className={styles.dropdown__link_icon}
                      viewBox="0 0 24 24"
                      width="18"
                      height="100%"
                      fill="currentColor"
                    >
                      <use href="/images/sprite.svg#blackjack"></use>
                    </svg>
                    {t("blackjack")}
                  </Link>
                </li>

                <li className={styles.dropdown__list_item}>
                  <Link className={styles.dropdown__link} href={"/games/poker"}>
                    <svg
                      className={styles.dropdown__link_icon}
                      viewBox="0 0 24 24"
                      width="18"
                      height="100%"
                      fill="currentColor"
                    >
                      <use href="/images/sprite.svg#poker"></use>
                    </svg>
                    {t("poker")}
                  </Link>
                </li>

                <li className={styles.dropdown__list_item}>
                  <Link className={styles.dropdown__link} href={"/games/game-shows"}>
                    <svg
                      className={styles.dropdown__link_icon}
                      viewBox="0 0 24 24"
                      width="18"
                      height="100%"
                      fill="currentColor"
                    >
                      <use href="/images/sprite.svg#games-show"></use>
                    </svg>
                    {t("game_shows")}
                  </Link>
                </li>

                {/* <li className={styles.dropdown__list_item}>
                  <Link className={styles.dropdown__link} href={"/"}>
                    <svg
                      className={styles.dropdown__link_icon}
                      viewBox="0 0 24 24"
                      width="18"
                      height="100%"
                      fill="currentColor"
                    >
                      <use href="/images/sprite.svg#all"></use>
                    </svg>
                    All Live Games
                  </Link>
                </li> */}
              </ul>
            )}
          </div>
        </li>

        <li className={styles.menu__item}>
          <Link className={styles.menu__link} href="/games/instant">
            <svg className={styles.menu__link_icon} viewBox="0 0 24 24" width="18" height="100%">
              <use href="/images/sprite.svg#burger-instans-dark"></use>
            </svg>
            <span className={styles.menu__link_title}>{t("instant_games")}</span>
          </Link>
        </li>
      </ul>
      <ul className={styles.menu__list}>
        <li className={styles.menu__item}>
          <Link className={styles.menu__link} href="/games">
            <svg className={styles.menu__link_icon} viewBox="0 0 24 24" width="18" height="100%">
              <use href="/images/sprite.svg#burger-games-dark"></use>
            </svg>
            <span className={styles.menu__link_title}>{t("all")}</span>
          </Link>
        </li>
        <li className={styles.menu__item}>
          <Link className={styles.menu__link} href="/providers">
            <svg className={styles.menu__link_icon} viewBox="0 0 24 24" width="18" height="100%">
              <use href="/images/sprite.svg#burger-providers-dark"></use>
            </svg>
            <span className={styles.menu__link_title}>{t("providers")}</span>
          </Link>
        </li>
      </ul>

      {isClose && (
        <div className={styles.info}>
          <ul className={styles.info__list}>
            <li className={styles.info__item}>
              <Link className={styles.info__link} href="/page/static-page">
                {t("news")}
              </Link>
            </li>

            <li className={styles.info__item}>
              <Link className={styles.info__link} href="/page/static-page">
                {t("terms")}
              </Link>
            </li>
          </ul>
        </div>
      )}

      <div className={styles.footer}>
        <CurrentTime />

        <LocaleSwitcher />
      </div>
    </div>
  );
}
